export default "function sayHello() {\nconsole.log(\"Hello world\");\n}"